import { createAsyncThunk } from '@reduxjs/toolkit';
export const asyncActionsFactory = () => (name, action, options) => {
    return createAsyncThunk(name, async (...args) => {
        try {
            return (await action(...args));
        }
        catch (e) {
            console.error(e);
            throw args[1].rejectWithValue(e);
        }
    }, options);
};
